import { trpc, TRPCReactQueryOptions } from '@sternum/web/services/trpc';

export function useLastUsedClient(options?: TRPCReactQueryOptions['auth']['getLastUsedClient']) {
  const { data, ...rest } = trpc.auth.getLastUsedClient.useQuery(undefined, {
    staleTime: Infinity,
    ...options,
  });

  return { lastUsedClient: data || null, ...rest };
}
